import React from 'react';

import { Line, PreviewTourContainer, Title } from './styles';
import { Tournament } from '../../api/responses';
import { Link, useLocation } from 'react-router-dom';
import TimeChain from '../TimeChain';

type TPreviewTournament = {
  data: Tournament;
};

const PreviewTournament = ({ data }: TPreviewTournament) => {
  const { pathname } = useLocation();

  return (
    <PreviewTourContainer>
      <TimeChain
        startDate={data.date_start}
        endDate={data.date_end}
        time={data.start_time}
        lang={data.competition_language === 'Russian' ? 'ru' : 'en'}
      />
      <Link to={`${pathname}/${data.id}`} reloadDocument>
        <Title>{data.name}</Title>
      </Link>
      <Line />
    </PreviewTourContainer>
  );
};

export default PreviewTournament;
